import { PopupModal } from "../../components/PopupModal";
import CloseIcon from "../../assets/icons/x.svg?react";
import PinIcon from "../../assets/icons/pin.svg?react";
import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { Button } from "../../components/Button";
import { TextInput } from "../../components/TextInput/TextInput";
import { api } from "../../services/api";
import { DOCUMENT_OWNER_TYPES } from "../../constant";
import { getUser } from "../../services/utils";

import { useFiles } from "../provider/Library/context/file-context"
import { TextArea } from "../../components/Textarea";
import { ShowToast } from "../../services/toast";
import { fileUpload } from "../../services/file-upload";

export function FeedbackModal({ onClose }) {
  const [loading, setLoading] = React.useState(false);
  // const { uploadingFiles } = useFiles() as any;
  const [feedbackText, setFeedbackText] = React.useState("");
  const [addFileMode, setAddFileMode] = React.useState(false);
  const [errors, setErrors] = React.useState<any>({});
  const [files, setFiles] = React.useState<File[]>([]);

  const handleFileChange = (fileList) => {
    setFiles(fileList);
  };

  const disabled = feedbackText.trim().length < 5

  const handleSubmit = async () => {
    if (disabled) {
      return;
    }

    setLoading(true);

    const attachedDocUrls: string[] = []
    for (const file of files) {
      try {
        const response = await fileUpload(file, getUser()?.id, "FEEDBACK");
        attachedDocUrls.push(response.url);
      } catch (error) {
        console.error("File upload failed:", error);
        ShowToast({
          message: "File upload failed. Please try again.",
          type: "error",
        });
        return;
      }
    }

    const createdAtDate = (new Date()).toISOString().split('T')[0]

    const response = await api.sendGeneralFeedback(feedbackText, createdAtDate, attachedDocUrls)
    if ([200, 201].includes(response.status)) {
      ShowToast({
        message: "We've successfully received your feedback",
        type: "success",
      });
    } else {
      ShowToast({
        message: response?.data?.message || "Something went wrong",
        type: "error",
      });
    }

    setLoading(false);

    // await uploadFiles(files);


    onClose();
  };


  return (
    <PopupModal
      contentClassName="p-8 z-[2] w-[98%] self-center bg-white rounded-2xl flex-col justify-start items-center gap-6 flex w-full md:mx-auto md:w-[542px] max-w-[542px]"
      onClose={onClose}
      shouldStopPropagation={false}
    >
      <>
        <div className="w-full justify-between items-start flex">
          <div className="text-black text-xl sm:text-2xl font-bold font-['Outfit']">
            Feedback
          </div>


          <div className="justify-end items-center gap-3 flex">
            <button onClick={onClose}>
              <CloseIcon className="w-6 h-6" />
            </button>
          </div>
        </div>
        <div className="text-black text-xs mr-auto sm:text-md mt-[-20px] font-['Outfit']">
          Share portal feedback with the Headstart team
        </div>
        <div className="w-full">
          <div className="flex flex-col gap-1.5 mb-8">
            {/* <span className="text-black/80 mt-0 text-sm">Feedback</span> */}
            <TextArea
              disabled={loading}
              className={`p-[10px] mt-[-10px]`}
              name="comments"
              rows={5}
              value={feedbackText}
              placeholder="What do you like or dislike about the portal? Any issues?"
              onChange={(e) => {
                setFeedbackText(e.target.value)
              }}
            />
            {addFileMode && <>
              <span className="text-black/80 text-sm">Add Images/File(s)</span>
              <FileUploader disabled={loading} handleChange={handleFileChange} name="file" multiple>
                <div className="cursor-pointer p-4 h-[114px] bg-[#E8F3F2] w-full rounded-xl border border-primary justify-center items-center gap-1 flex">
                  <PinIcon className="w-5 h-5" />
                  <div className="text-primary text-base font-normal font-['Outfit'] leading-normal">
                    {files.length > 0
                      ? `${files.length} files added`
                      : "Click to add or drag and drop"}
                  </div>
                </div>
              </FileUploader>
              {errors.files && (
                <div className="text-red-500 text-xs font-medium">
                  {errors.files}
                </div>
              )}
            </>}
            {!addFileMode && <div>
              <span className="underline cursor-pointer inline-block text-xs sm:text-base" onClick={() => setAddFileMode(true)}>Add Image/File(s)</span>
            </div>}
          </div>

          <Button
            disabled={disabled || loading}
            variant="primary"
            className="!rounded-full w-full text-xs sm:text-base"
            onClick={handleSubmit}
            loading={loading}
          >
            Submit Feedback
          </Button>
        </div>
      </>
    </PopupModal>
  );
}